import React from 'react';
import { Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useNavigateWithScrollMemory } from '../../hooks/useNavigateWithScrollMemory';
import { getPageTypeFromPath } from '../../lib/gaParams';
import { trackArtistNameClick } from '../../lib/gaEvents';
import { useUserStore } from '../../stores/userStore';

const ArtistLink = ({ artistName, artistSource, artistSourceId, artistSlug, artistDbId, sx, onClick }) => {
  const navigateWithScrollMemory = useNavigateWithScrollMemory();
  const location = useLocation();
  const user = useUserStore((state) => state.user);
  const displayName = artistName || 'Unknown Artist';
  const canClick = artistSourceId !== 'unknown' && (artistSlug || (artistSource && artistSourceId));
  const artistUrl = canClick
    ? artistSlug
      ? artistDbId
        ? `/artists/${artistSlug}`
        : `/artists/${artistSlug}?source_id=${artistSourceId}`
      : `/artists/${artistSource.toLowerCase()}/${artistSourceId}`
    : '#';

  const artistLinkState = { sourceId: artistSourceId, sourceType: artistSource };

  const handleClick = (e) => {
    if (canClick) {
      e.stopPropagation();
      onClick?.();
      trackArtistNameClick(
        {
          contentId: artistSourceId,
          contentName: displayName,
          pageType: getPageTypeFromPath(location.pathname),
        },
        user,
      );
      if (!e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        navigateWithScrollMemory(artistUrl, { state: artistLinkState });
      }
    } else {
      e.preventDefault();
    }
  };

  return (
    <RouterLink
      to={artistUrl}
      state={artistLinkState}
      onClick={handleClick}
      style={{
        textDecoration: 'none',
        color: 'inherit',
        pointerEvents: canClick ? 'auto' : 'none',
      }}
    >
      <Typography
        sx={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          cursor: canClick ? 'pointer' : 'default',
          lineHeight: 'normal',
          ...sx,
        }}
        title={displayName}
      >
        {displayName}
      </Typography>
    </RouterLink>
  );
};

export default ArtistLink;
